import { Utils } from '@/libs/Utils'
import Link from 'next/link'
import React from 'react'

const Previous: React.FC<{ href: string, locale: string }> = ({
    href = "",
    locale
}) => {
    const t = new Utils(locale).Translation

    return (
        <li key='previous-page' className='item pagination_previous-page'>
            <Link
                href={href}
                passHref>
                {t("pagination.previous")}
            </Link>
        </li>
    )
}

export default Previous